<template>
  <div class="recordsContainer">
    <RecordItem
      v-for="item in launchedRecords"
      :key="item.id"
      :data="item"
      :timeStr="`发起时间：${timeStr(item)}`"
      :defaultAvatarImage="defaultAvatarImage"
      isShowTag
      isShowProgress
      @clickGoActHome="handleClickGoActHome"
      @clickGoAwards="handleClickGoAwards"
    />
    <div class="empty" v-if="launchedRecords.length === 0">
      <div class="emptyIcon"></div>
      <div class="note">您还没有发起任何活动哦～</div>
      <div class="goHomeBtn" @click="handleGoHome">去参加活动</div>
    </div>
    <div class="noMore" v-if="launchedRecords.length">
      没有更多了~
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import RecordItem from './RecordItem';
import { toDayDate } from '@/components/templates/helper';
export default {
  components: { RecordItem },
  props: {
    defaultAvatarImage: String
  },
  methods: {
    timeStr(data) {
      return toDayDate(data.startTime, 'yyyy.MM.dd hh:mm');
    },
    handleClickGoActHome() {
      this.$emit('reportEvent', {
        event: 'invite_boost_coupon_activity_click',
        module_name: '我发起的',
        button_name: '查看活动'
      });
    },
    handleClickGoAwards() {
      this.$emit('reportEvent', {
        event: 'invite_boost_coupon_activity_click',
        module_name: '我发起的',
        button_name: '查看奖品'
      });
    },
    handleGoHome() {
      this.$router.push('/');
      this.$emit('reportEvent', {
        event: 'invite_boost_coupon_activity_click',
        module_name: '缺省页',
        button_name: '去参加活动'
      });
    }
  },
  computed: {
    ...mapState('app/inviteEarnCoupon/playHistory', {
      launchedRecords: 'launchedRecords'
    })
  }
};
</script>

<style lang="less" scoped>
.recordsContainer {
  .fcc;
  padding-top: 38px;

  .noMore {
    margin: 30px 0;
    text-align: center;
  }
}

.empty {
  margin: 300px;
  text-align: center;
  .fcc;

  .emptyIcon {
    width: 392px;
    height: 254px;
    background: center / cover no-repeat url('../../assets/images/empty.png');
  }

  .note {
    margin-top: 30px;
    color: #8c8c8c;
    font-size: 30px;
  }

  .goHomeBtn {
    margin-top: 30px;
    width: 450px;
    height: 88px;
    background: linear-gradient(to top, #ff0044 0%, #ff4153 38%, #fd515f 99%);
    border-radius: 44px;
    .fc;
    color: #fff;
    font-size: 36px;
  }
}
</style>
